import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { Button, Form } from 'react-bootstrap';
import '../../Modal.css';

Modal.setAppElement('#root'); // This is necessary for accessibility reasons

const TrackValidationModal = ({
  show,
  onHide,
  onSave,
  circuitGeojson,
  finishLineGeojson,
  confirmzoneGeojson,
  circuitNameInit,
  countryCodeInit,
}) => {
  const [countryCode, setCountryCode] = useState(countryCodeInit || 'FR'); // Default to France
  const [trackName, setTrackName] = useState(circuitNameInit || '');
  const [trackStatus, setTrackStatus] = useState('Incomplete');
  const [finishLineStatus, setFinishLineStatus] = useState('Incomplete');
  const [confirmZoneStatus, setConfirmZoneStatus] = useState('Incomplete');

  useEffect(() => {
    setCountryCode(countryCodeInit || 'FR');
    setTrackName(circuitNameInit || '');
  }, [circuitNameInit, countryCodeInit]);

  const validateTrack = () => {
    const trackComplete = circuitGeojson && circuitGeojson.geometry.coordinates.length > 20;
    const finishLineComplete = finishLineGeojson && finishLineGeojson.geometry.coordinates.length === 2;
    const confirmZoneComplete = confirmzoneGeojson !== null;

    setTrackStatus(trackComplete ? 'Complete' : 'Incomplete');
    setFinishLineStatus(finishLineComplete ? 'Complete' : 'Incomplete');
    setConfirmZoneStatus(confirmZoneComplete ? 'Complete' : 'Incomplete');
  };

  const handleSave = () => {
    const trackData = {
      trackName,
      countryCode,
      circuitGeojson,
      finishLineGeojson,
      confirmzoneGeojson,
    };
    onSave(trackData);
    onHide();
  };

  useEffect(() => {
    if (show) validateTrack();
  }, [show, circuitGeojson, finishLineGeojson, confirmzoneGeojson]);

  const getStatusStyle = (status) => {
    return { color: status === 'Complete' ? 'green' : 'red' };
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={onHide}
      className="modal-content"
      overlayClassName="modal-overlay"
      contentLabel="Validate and Save Track Modal"
    >
      <div className="modal-header">
        <h5 className="modal-title">Validate and Save Track</h5>
        <button type="button" className="close" onClick={onHide}>
          <span>&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form>
          <Form.Group controlId="formTrackName">
            <Form.Label>Track Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter track name"
              value={trackName}
              onChange={(e) => setTrackName(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formCountryCode">
            <Form.Label>Country Code</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter 2-letter country code"
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value.toUpperCase())}
            />
          </Form.Group>
          <hr />
          <p>
            <strong>Track Status:</strong>{' '}
            <span style={getStatusStyle(trackStatus)}>{trackStatus}</span>
          </p>
          <p>
            <strong>Finish Line Status:</strong>{' '}
            <span style={getStatusStyle(finishLineStatus)}>{finishLineStatus}</span>
          </p>
          <p>
            <strong>Confirm Zone Status:</strong>{' '}
            <span style={getStatusStyle(confirmZoneStatus)}>{confirmZoneStatus}</span>
          </p>
        </Form>
      </div>
      <div className="modal-footer">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={
            !(
              trackStatus === 'Complete' &&
              finishLineStatus === 'Complete' &&
              confirmZoneStatus === 'Complete'
            )
          }
        >
          Save Track
        </Button>
      </div>
    </Modal>
  );
};

export default TrackValidationModal;
